import { memo , useState, useEffect} from "react"
import ProductItem from "@/components/product/item"
import { SimpleGrid } from "@chakra-ui/react"
const ProductList = ({ data = [] }) => {
    const [lst, setLst] = useState([]);

    return (

        <SimpleGrid columns={2} columnGap="2" rowGap="4">
            {data.map(x => <ProductItem data={x}></ProductItem>)}
        </SimpleGrid>


    )
}

export default memo(ProductList)